import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import {
  Construction as ConstructionIcon,
} from '@mui/icons-material';

function PlaceholderPage({ title, description }) {
  return (
    <Box>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {description}
      </Typography>

      <Paper
        sx={{
          p: 6,
          textAlign: 'center',
          backgroundColor: 'background.paper',
        }}
      >
        <ConstructionIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary">
          Coming Soon
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This section is under development.
        </Typography>
      </Paper>
    </Box>
  );
}

export default PlaceholderPage;
